export class ProposalHistoricalStatLineItem {
    period!: string
    totalSpend!: number
    avgDailySpend!: number
    totalSentLeads!: number
    costPerSentLead!: number
}